import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import {
  GlobalErrorHandler,
  HttpLoadingInterceptor,
  LanguageInterceptor,
  provideMsalAuth,
  TimezoneOffsetInterceptor,
} from '#core';
import { LanguageLoader } from '#locale';
import { routes } from './app.routes';
import { DialogService } from 'primeng/dynamicdialog';
import { LoadingIndicatorService } from '#services';
import { primetheme } from '../styles/primetheme';
import { appInitializer } from './app-initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(appInitializer),
    provideMsalAuth(),
    provideTranslateService({
      loader: provideTranslateLoader(LanguageLoader),
      fallbackLang: 'en',
      lang: 'en',
    }),

    providePrimeNG({
      theme: {
        preset: primetheme,
        options: {
          darkModeSelector: false,
        },
      },
      ripple: true,
    }),
    MessageService,
    ConfirmationService,
    provideAnimationsAsync(),
    DialogService,
    LoadingIndicatorService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimezoneOffsetInterceptor,
      multi: true,
    },
  ],
};
